import {
  MagnifyingGlassIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import { useCallback, useRef } from 'react';

interface Props {
  onClickSafe?: () => void;
  onClickInvestigate?: () => void;
  hideActionText?: boolean;
}

export function CamFeedActions(props: Props) {
  const { onClickInvestigate, onClickSafe, hideActionText } = props;
  return (
    <div className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 group-hover/feed:block">
      <div className="flex gap-2">
        {onClickSafe && (
          <FeedActionButton
            icon={ShieldCheckIcon}
            text="Safe"
            onClick={() => onClickSafe?.()}
            hideText={!!hideActionText}
          />
        )}
        {onClickInvestigate && (
          <FeedActionButton
            icon={MagnifyingGlassIcon}
            text="Investigate"
            onClick={() => onClickInvestigate?.()}
            hideText={!!hideActionText}
          />
        )}
      </div>
    </div>
  );
}

interface FeedActionButtonProps {
  text: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick: () => void;
  hideText?: boolean;
}

function FeedActionButton(props: FeedActionButtonProps) {
  const { text, onClick, icon, hideText } = props;
  const lastClickRef = useRef(0);

  const ActionIcon = icon;

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();

      const now = Date.now();
      if (now - lastClickRef.current > 300) {
        lastClickRef.current = now;
        onClick?.();
      }
    },
    [onClick]
  );

  return (
    <button
      onClick={handleClick}
      onDoubleClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
      }}
      title={text}
      className="flex items-center gap-1 rounded bg-black/50 px-3 py-1 text-xs font-semibold text-white transition-colors hover:bg-black/80"
    >
      <ActionIcon className="h-5 w-5 text-white" />
      {!hideText && text}
    </button>
  );
}

export default CamFeedActions;
